import { PoolLeagueApiClient } from '../base-client/pool-league-api-client';
import { Injectable } from '@angular/core';
import { GET_LATEST_RESULTS, Result } from '@pool-league/shared-data-api';

@Injectable({ providedIn: 'root' })
export class ResultsApiClient extends PoolLeagueApiClient {
  readonly #getResults = this.buildRequest(GET_LATEST_RESULTS);

  getResults(limit: number) {
    return this.#getResults.get<Result[]>({
      params: { limit },
    });
  }
}
